import React from 'react';
import './CadastroFormDrawer.css';

function CadastroFormDrawer({ open, onClose, title, children }) {
    if (!open) return null;

    return (
        <>
            <div className="cadastro-form-drawer-backdrop" onClick={onClose} aria-hidden="true" />
            <aside className="cadastro-form-drawer" role="dialog" aria-label={title}>
                <div className="cadastro-form-drawer__header">
                    <h2 className="cadastro-form-drawer__title">{title}</h2>
                    <button type="button" className="cadastro-form-drawer__close" onClick={onClose} aria-label="Fechar">
                        <i className="fas fa-times" />
                    </button>
                </div>
                <div className="cadastro-form-drawer__body">
                    {children}
                </div>
            </aside>
        </>
    );
}

export default CadastroFormDrawer;
